import { Grid2 as Grid } from '@mui/material'
import { Field } from 'formik'
import React from 'react'
import PropTypes from 'prop-types'
import HourMinutesText from './HoursMinutesText'

const BetweenTimes = ({ startName, startLabel = 'Start', endName, endLabel = 'End', size, disabled, placeholder }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Field label={startLabel} name={startName} component={HourMinutesText} size={size} disabled={disabled} placeholder={placeholder?.start} />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Field label={endLabel} name={endName} component={HourMinutesText} size={size} disabled={disabled} placeholder={placeholder?.end} />
      </Grid>
    </Grid>
  )
}

BetweenTimes.propTypes = {
  startName: PropTypes.string.isRequired,
  startLabel: PropTypes.string,
  endName: PropTypes.string.isRequired,
  endLabel: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.shape({ start: PropTypes.string, end: PropTypes.end }),
}

export default BetweenTimes
